import React from "react";
import { Box, Stack } from "@mui/joy";

interface PageHeaderProps {
  children: React.ReactNode;
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  children,
  className = "",
}) => {
  // Convert children to array for easier manipulation
  const childArray = React.Children.toArray(children);

  // Assume the first child is the heading, rest are actions
  const heading = childArray[0];
  const actions = childArray.slice(1);

  return (
    <Box
      className={className}
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: { xs: "flex-start", sm: "space-between" },
        alignItems: { xs: "flex-start", sm: "center" },
        my: 1, // margin top and bottom (1.5rem)
        py: 1, // padding top and bottom (1rem)
        gap: { xs: 2, sm: 3 },
        flexWrap: "wrap",
        minWidth: 0, // Allow flex items to shrink below content size
      }}
    >
      <Box sx={{ flexShrink: 1, minWidth: 0 }}>{heading}</Box>
      {actions.length > 0 && (
        <Stack
          direction="row"
          spacing={2}
          sx={{
            flexShrink: 1,
            minWidth: 0,
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          {actions}
        </Stack>
      )}
    </Box>
  );
};

export default PageHeader;
